module.exports = __webpack_public_path__ + "img/20190928142827360截图20190928132328650.bcfafd2a.jpg";